import * as React from 'react';
import get from 'lodash.get';
import { Card, MuiBox, MuiCardActionArea, MuiCardContent, Typography } from '@kis-technologies/kis-ui';
import { CardContainerProps } from './types';
import { selectors as configSelectors, Configuration } from 'services/configuration';
import { useSelector } from 'react-redux';
import { useStyles } from './styled';

/**
 * Renders card tile with data
 */

export const CardContainer = (props: CardContainerProps) => {
  const { imgSrc, descText, testId, cardAction, isSelected, altText } = props;

  const config = useSelector(configSelectors.selectConfiguration) as Configuration;
  const fontFamily = get(config, 'configuration.globalSettings.fonts.primary');
  const primaryPalette = get(config, 'configuration.globalSettings.palette.primary');

  const classes = useStyles({ fontFamily })();

  return (
    <MuiBox className={classes.cardBoxOuterContainer}>
      <Card hasBorderRadius raised hasBorder={isSelected} borderColor={primaryPalette}>
        <MuiCardActionArea disableTouchRipple data-testid={testId} onClick={cardAction}>
          <MuiCardContent className={classes.cardBoxContainer}>
            <MuiBox className={classes.cardBoxImage}>
              <img src={imgSrc} alt={altText} className={classes.cardImage} />
            </MuiBox>
            <MuiBox className={classes.cardDescriptionBox}>
              <Typography className={classes.cardDescText}>{descText}</Typography>
            </MuiBox>
          </MuiCardContent>
        </MuiCardActionArea>
      </Card>
    </MuiBox>
  );
};
